import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  superadmin_header,
  admin_header,
  employee_header,
  user_header

} from "./Sidebar_path";
import { getEmployee_permissiondata } from "../../Services/Employee/Employee";
import { getUserFromToken } from "../../Utils/TokenVerify";
import { getAllClient } from "../../Services/Superadmin/Superadmin";
import * as Icons from "lucide-react";
const Sidebar = () => {
  const location = useLocation();
  const TokenData = getUserFromToken();

  const user_id = TokenData?.user_id;
  const roles = TokenData?.Role;
  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const [getaccess, setGetaccess] = useState({});
  const [researchPermission, setResearchPermission] = useState(0);

  useEffect(() => {
    getallclient();
  }, []);
  const getpermission = async () => {
    try {
      const data = { id: user_id };
      const response = await getEmployee_permissiondata(data);
      if (response.status) {
        setGetaccess(response.data[0]);
      }
    } catch (error) { }
  };




  let routes =
    roles === "SUPERADMIN"
      ? superadmin_header
      : roles === "ADMIN"
        ? admin_header
        : roles === "EMPLOYE" || roles === "EMPLOYEE"
          ? employee_header
          : roles === "USER"
            ? user_header
            : [];







  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      setResearchPermission(response.data.research_permission);
    } catch (error) { }
  };



  useEffect(() => {
    if (roles === "EMPLOYE") {
      getpermission();
    }
  }, [user_id]);

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location.pathname]);

  // const getIconClass = (name) => {
  //   switch (name.toLowerCase()) {
  //     // COMMON / EXISTING
  //     case "dashboard":
  //       return "fa-solid fa-house";
  //     case "employees":
  //       return "fa-solid fa-users";
  //     case "users":
  //       return "fa fa-user";
  //     case "position":
  //       return "fa fa-id-badge";
  //     case "transaction":
  //       return "fa-solid fa-money-bill-transfer";
  //     case "license history":
  //       return "fa-solid fa-money-bill-transfer";
  //     case "withdrawal":
  //       return "fa-solid fa-money-simple-from-bracket";
  //     case "deposit":
  //       return "fa-sharp fa-light fa-money-bill";
  //     case "reports":
  //       return "fa fa-file-text";
  //     case "trade history":
  //       return "fa-sharp fa-solid fa-clock-rotate-left";
  //     case "login status":
  //       return "fa-solid fa-signal-bars";
  //     case "broadcast":
  //       return "fa-solid fa-tower-broadcast";
  //     case "hold off":
  //       return "fa-solid fa-power-off";
  //     case "available positions":
  //       return "fa-solid fa-crosshairs";
  //     case "admin":
  //       return "fa fa-user";
  //     case "currency setup":
  //       return "fa-regular fa-coin";
  //     case "sign up":
  //       return "fa-solid fa-right-to-bracket";
  //     case "brokerage":
  //       return "fa fa-hand-holding-usd";
  //     case "bonus":
  //       return "fa fa-hand-holding-usd";
  //     case "research":
  //       return "fa-solid fa-bolt";
  //     case "chat-box":
  //       return "fa-solid fa-comments";
  //     case "user detail":
  //       return "fa fa-user";
  //     case "symbols":
  //       return "fa-sharp fa-light fa-money-bill";
  //     case "transfer":
  //       return "fa-solid fa-arrow-right-arrow-left";
  // case "Researchs":
  //       return "fa-sharp fa-light fa-money-bill";

  //     /* -------------------------------
  //        USER APP NEW MENU ITEMS
  //     --------------------------------*/

  //     case "option chain":
  //       return "fa-solid fa-chart-line";

  //     case "news":
  //       return "fa-solid fa-newspaper";

  //     case "trade statement":
  //       return "fa-solid fa-file-invoice";

  //     case "ledger report":
  //       return "fa-solid fa-book";

  //     case "balance statement":
  //       return "fa-solid fa-wallet";

  //     case "registered bank":
  //       return "fa-solid fa-building-columns";

  //     case "kyc document":
  //     case "kyc":
  //       return "fa-solid fa-id-card";

  //     case "privacy policy":
  //       return "fa-solid fa-shield-halved";

  //     case "terms & conditions":
  //     case "terms":
  //       return "fa-solid fa-scale-balanced";

  //     case "refer & earn":
  //       return "fa-solid fa-share-nodes";

  //     case "logout":
  //       return "fa-solid fa-right-from-bracket";
  //       case "orders":
  //   return "fa-solid fa-list-check";

  // case "watchlist":
  //   return "fa-solid fa-eye";

  // case "portfolio":
  //   return "fa-solid fa-briefcase";


  //     default:
  //       return "fa-solid fa-circle"; // fallback icon
  //   }

  // };

  const getIconComponent = (name) => {
    switch (name.toLowerCase()) {
      case "dashboard":
        return Icons.LayoutDashboard;

      case "employees":
      case "users":
      case "admin":
      case "user detail":
        return Icons.Users;

      case "transaction":
        return Icons.DollarSign;

      case "trade history":
        return Icons.Activity;

      case "login status":
        return Icons.Signal;

      case "broadcast":
        return Icons.Radio;

      case "hold off":
        return Icons.Power;

      case "available positions":
        return Icons.Target;

      case "withdrawal":
        return Icons.ArrowDownCircle;

      case "deposit":
        return Icons.ArrowUpCircle;

      case "bonus":
        return Icons.Gift;

      case "research":
        return Icons.Zap;

      case "chat-box":
        return Icons.MessageSquare;

      case "transfer":
        return Icons.Repeat;

      case "orders":
        return Icons.ListChecks;

      case "watchlist":
        return Icons.Eye;

      case "portfolio":
        return Icons.Briefcase;

      case "option chain":
        return Icons.LineChart;

      case "news":
        return Icons.Newspaper;

      case "trade statement":
        return Icons.FileText;

      case "ledger report":
        return Icons.Book;

      case "balance statement":
        return Icons.Wallet;

      case "registered bank":
        return Icons.Building;

      case "kyc document":
      case "kyc":
        return Icons.Building;

      case "privacy policy":
        return Icons.Shield;

      case "terms & conditions":
        return Icons.Scale;

      case "refer & earn":
        return Icons.Share2;

        case "sign up":
          return Icons.LogIn;

          case "payment history":
            return Icons.Clock;

            case "option chain1":
              return Icons.LineChart;

              case "my favorites":
                return Icons.Star;

      default:
        return Icons.Circle;


    }
  };
  return (
    <div className="dlabnav follow-info">
      <div className="menu-scroll">
        <div className="dlabnav-scroll mm-active">
          <ul className="metismenu mm-show" id="menu">
            {routes &&
              routes.map((data) => {
                if (
                  (roles === "EMPLOYE" &&
                    data.name.toLowerCase() === "available positions" &&
                    getaccess.open_position !== 1) ||
                  (roles === "EMPLOYE" &&
                    data.name.toLowerCase() === "trade history" &&
                    getaccess.trade_history !== 1)

                ) {
                  return null;
                }


                if (data.name == "Research" && researchPermission == 0) {
                  return null;

                }

                return (
                  <li
                    key={data.id}
                    className={`mm ${activeRoute === data.route ? "mm-active" : ""
                      }`}
                    onClick={() => setActiveRoute(data.route)}
                  >
                    {/* <Link to={data.route} aria-expanded="false">
                      <i className={getIconClass(data.name)}></i>
                      <span className="nav-text">{data.name}</span>
                    </Link> */}
                    <Link to={data.route} aria-expanded="false">
                      {(() => {
                        const Icon = getIconComponent(data.name);
                        return <Icon size={18} />;
                      })()}
                      <span className="nav-text">{data.name}</span>
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
